import { render, staticRenderFns } from "./customerInteraction.vue?vue&type=template&id=355595f4&scoped=true"
import script from "./customerInteraction.vue?vue&type=script&lang=js"
export * from "./customerInteraction.vue?vue&type=script&lang=js"
import style0 from "./customerInteraction.vue?vue&type=style&index=0&id=355595f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355595f4",
  null
  
)

export default component.exports